import { VerticalType } from '../types';

/**
 * Controls which verticals are visible in the app.
 *
 * Set REACT_APP_VISIBLE_VERTICALS in Cloudflare Pages (or .env) to:
 *   LAB  — only show Anatomical Pathology
 *   MSO  — only show MSO Formation
 *   BOTH — show both (default)
 */
const raw = (process.env.REACT_APP_VISIBLE_VERTICALS || 'BOTH').toUpperCase();

export const verticalConfig = {
  showLab: raw === 'LAB' || raw === 'BOTH',
  showMso: raw === 'MSO' || raw === 'BOTH',
};

export const isSingleVertical = !verticalConfig.showLab || !verticalConfig.showMso;

export const getDefaultVertical = (): VerticalType => {
  if (verticalConfig.showLab) return 'pathology';
  return 'mso';
};
